var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteVendor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137",
    transform: "translate(0 -0.306)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_128",
    "data-name": "Rectangle 128",
    width: 20,
    height: 20,
    transform: "translate(0 0.306)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M1753.956,1659.95a.359.359,0,0,0-.341-.248h-.33a.359.359,0,0,0-.341.248l-.468,1.446a.358.358,0,0,0,.005.236l.633,1.7a.359.359,0,0,0,.672,0l.633-1.7a.362.362,0,0,0,.005-.236Z",
    transform: "translate(-1740.423 -1648.836)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159",
    transform: "translate(0 -0.505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M1743.136,1618.245a3.262,3.262,0,0,0,2.381.5,2.631,2.631,0,0,0,1.588-.87,2.838,2.838,0,0,0,.625-2.417,2.872,2.872,0,0,0-2.522-2.4l-.408-.055h-.116a.988.988,0,0,1-.156.031,2.829,2.829,0,0,0-1.025.246,2.907,2.907,0,0,0-1.6,3.1A2.606,2.606,0,0,0,1743.136,1618.245Z",
    transform: "translate(-1732.12 -1610.691)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M1749.47,1653.427a4.488,4.488,0,0,0-4.488-4.488h-.708a.66.66,0,0,1,.556.3l.131.2a.66.66,0,0,1-.024.747l-.182.248a.66.66,0,0,1-1.064,0l-.182-.248a.66.66,0,0,1-.024-.747l.131-.2a.66.66,0,0,1,.556-.3h-.708a4.472,4.472,0,0,0-2.33.651,1.134,1.134,0,0,1,.245.7v5.98h8.092Zm-4.307-.594-.615,1.651a.348.348,0,0,1-.652,0l-.615-1.651a.349.349,0,0,1-.005-.229l.454-1.4a.348.348,0,0,1,.331-.241h.32a.348.348,0,0,1,.331.241l.454,1.4A.349.349,0,0,1,1745.163,1652.833Z",
    transform: "translate(-1731.516 -1639.88)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M1707.748,1655.159a.2.2,0,0,0-.146-.066h-6.452a.2.2,0,0,0-.2.2v7.553a.2.2,0,0,0,.2.2h6.452a.2.2,0,0,0,.2-.2v-7.553A.2.2,0,0,0,1707.748,1655.159Zm-.86,4.49a.469.469,0,0,1-.469.469h-1.209a.469.469,0,0,1,0-.939h1.209A.469.469,0,0,1,1706.888,1659.649Zm-4.028-4.078h3.03a.469.469,0,1,1,0,.939h-3.03a.469.469,0,1,1,0-.939Zm-.693,2.083h3.327a.469.469,0,1,1,0,.939h-3.327a.469.469,0,0,1,0-.939Zm0,1.525h1.664a.469.469,0,1,1,0,.939h-1.664a.469.469,0,0,1,0-.939Zm2.638,2.464h-2.638a.469.469,0,0,1,0-.939h2.638a.469.469,0,1,1,0,.939Z",
    transform: "translate(-1698.878 -1644.879)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M1713.829,1646.009h-1.761a.563.563,0,0,0-.563.563.568.568,0,0,0,.563.563h1.761a.563.563,0,0,0,0-1.127Z",
    transform: "translate(-1707.45 -1637.5)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteVendor);
export default __webpack_public_path__ + "static/media/white_vendor.52daa38609b960ae386fa95c8dc8de46.svg";
export { ForwardRef as ReactComponent };